/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

function RecentlyRunAutomation({ localizations, ...props }) {
  return (
    <li className="slds-item">
      <div className="slds-tile">
        <h3 className="slds-truncate">
          <a href={props.url} onClick={props.onClick}>
            {props.name}
          </a>
        </h3>
        <div className="slds-tile__detail slds-text-body--small">
          <p className="slds-text-color--weak">
            <FormattedMessage
              id="homepage.cards.last_ran_on"
              values={{
                run_date: props.lastRunTime,
                run_time: props.lastRunTime,
              }}
            />
          </p>
          <div className="slds-grid slds-wrap">
            <div className="slds-size--1-of-2">
              <div className="slds-text-color--weak slds-truncate" title={localizations['homepage.cards.last_status']}>
                {localizations['homepage.cards.last_status']}
              </div>
              <div className="slds-truncate">{props.lastRunStatus}</div>
            </div>
            <div className="slds-size--1-of-2">
              <div
                className="slds-text-color--weak slds-truncate"
                title={localizations['homepage.cards.automation_next_scheduled']}
              >
                {localizations['homepage.cards.automation_next_scheduled']}
              </div>
              {props.scheduledTime ? (
                <div className="slds-truncate">
                  <FormattedDate value={props.scheduledTime} /> <FormattedTime value={props.scheduledTime} />
                </div>
              ) : (
                <div>{localizations['homepage.cards.automation_not_scheduled']}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}

RecentlyRunAutomation.displayName = 'Recently Run Automation';

RecentlyRunAutomation.propTypes = {
  lastRunStatus: PropTypes.string,
  lastRunTime: PropTypes.number,
  localizations: PropTypes.object,
  name: PropTypes.string,
  onClick: PropTypes.func,
  scheduledTime: PropTypes.number,
  url: PropTypes.string,
};

RecentlyRunAutomation.defaultProps = {
  url: 'javascript:void(0);', // eslint-disable-line no-script-url
};

export default RecentlyRunAutomation;
